import type { FC } from "react";
import classes from "./watermark.module.scss";

const Watermark: FC = () => {
  return (
    <div className={classes["watermark-container"]}>
      The chatbot responses are generated using Generative AI technology. Please
      review for accuracy.
    </div>
  );
};

export default Watermark;
